export default {
    en: {
        resumeDateTitle: 'Payment date',
        resumeDateDisclaimerText:
            'One last automatic payment will be withdrawn from your account on {{date, MMMM\xa0D}}, {{date, YYYY}} before your new payment frequency starts.',
        resumeDatePremierPaiementTitle: 'First payment with your new frequency',
        resumeDatePremierPaiementValeur:
            '{{date, dddd}}, {{date, MMMM\xa0D}}, {{date, YYYY}}',
        resumeChangeButton: 'Edit',
        resumeChangeButtonLabelHorsEcran: 'payment date'
    },
    fr: {
        resumeDateTitle: 'Date de paiement',
        resumeDateDisclaimerText:
            'Un dernier paiement automatique sera prélevé de votre compte le {{date, D}}{{suffixe}}\xa0{{date, MMMM\xa0YYYY}} avant le début de la nouvelle fréquence de paiement.',
        resumeDatePremierPaiementTitle:
            'Premier paiement à la nouvelle fréquence',
        resumeDatePremierPaiementValeur:
            '{{date, D}}{{suffixe}}\xa0{{date, MMMM\xa0YYYY}}',
        resumeChangeButton: 'Modifier',
        resumeChangeButtonLabelHorsEcran: 'la date de paiement'
    }
};
